<script setup lang="ts">
defineProps<{
  icon: string
  label: string
  value?: string
  items?: string[]
  preferred?: boolean
}>()
</script>

<template>
  <div class="space-y-2">
    <h3 class="font-medium text-gray-900 flex items-center gap-2">
      <Icon
        :name="icon"
        class="w-4 h-4"
        :class="preferred ? 'text-amber-500' : 'text-amber-600'"
      />
      {{ label }}
    </h3>
    <p
      v-if="value"
      class="text-gray-700 text-sm"
    >
      {{ value }}
    </p>
    <ul
      v-if="items?.length"
      class="space-y-1"
    >
      <li
        v-for="(item, idx) in items"
        :key="idx"
        class="text-gray-700 text-sm flex items-center gap-2"
      >
        <span class="w-1.5 h-1.5 rounded-full bg-amber-600" />
        {{ item }}
      </li>
    </ul>
  </div>
</template>
